import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Add Management
export const addManagementAPI = async ({ data }) => {
  try {
    // ✅ data already contains company_id
    const response = await apiService.post(endpoints.addManagement, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Management
export const updateManagementAPI = async ({ company_employee_id, data }) => {
  try {
   
    const endpoint = endpoints.updateManagement.replace('{company_employee_id}', company_employee_id);
    
    const response = await apiService.put(endpoint, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Delete Management
export const deleteManagementAPI = async ({ company_employee_id, company_id }) => {
  try {
    const url = company_id 
      ? `/company/management/delete/${company_employee_id}?company_id=${company_id}`
      : `/company/management/delete/${company_employee_id}`;
    
    console.log('Delete API URL:', url);
    console.log('company_employee_id:', company_employee_id);
    console.log('company_id:', company_id);
    
    const response = await apiService.delete(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Resend HR Invite
export const resendHrInviteAPI = async ({ companyId }) => {
  try {
    const endpoint = endpoints.resendHrInvite.replace('{companyId}', companyId);
    
    console.log('Resend HR Invite URL:', endpoint);
    console.log('companyId:', companyId);
    
    const response = await apiService.post(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Managements List (with pagination + search)
export const getManagementsListAPI = async ({
  company_id,
  page = 1,
  limit = 10,
  search = "",
  sort,
  order,
} = {}) => {
  try {
    const params = { company_id: company_id, page, limit, search };
    if (sort) params.sort = sort;
    if (order) params.order = order;
    const response = await apiService.get(endpoints.getManagementsList, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get All Managements (simple get - no params)
export const getManagementsAPI = async () => {
  try {
    const response = await apiService.get(endpoints.getHrManagement);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Management Detail
export const getManagementDetailAPI = async ({ companyId, managementId }) => {
  try {
    const params = { 
      company_id: companyId,
      management_id: managementId 
    };
    const response = await apiService.get(endpoints.getManagementDetail, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Import Managements via CSV
export const importManagementsCsvAPI = async ({ companyId, formData }) => {
  try {
    const params = { company_id: companyId };
    const response = await apiService.postFormData(endpoints.importManagementsCsv, formData, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}; 

